function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import "./round-input.scss";
import template from "./round-input.html";

export var InputRoundComponent = {
  template: template,
  require: {
    model: "ngModel" },

  bindings: {
    id: "@",
    label: "@",
    viewName: "@",
    type: "@",
    isRequired: "@",
    minimumLength: "@",
    maximumLength: "@",
    min: "@",
    max: "@",
    autofocus: "<",
    step: "@" },

  controller: /*#__PURE__*/function () {InputRoundComponentController.$inject = ["LayoutService", "$element", "$timeout"];

    function InputRoundComponentController(LayoutService, $element, $timeout) {
      "ngInject";var _this = this;_classCallCheck(this, InputRoundComponentController);
      this.LayoutService = LayoutService;
      this.$element = $element;
      this.$timeout = $timeout;
      console.log(this);
      this.onChange = function () {
        _this.model.$setViewValue(_this.value);
      };
    }_createClass(InputRoundComponentController, [{ key: "$onInit", value: function $onInit()

      {var _this2 = this;
        this.model.$render = function () {
          _this2.value = _this2.model.$viewValue;
        };
      } }, { key: "$postLink", value: function $postLink()

      {var _this3 = this;
        this.input = this.$element.find('input')[0];
        if (this.autofocus) this.$timeout(function () {return _this3.input.focus();});
      } }]);return InputRoundComponentController;}() };